import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQuery } from '@/lib/baseQuery';

export const referAPI = createApi({
  reducerPath: 'referAPI',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getReferralLinks: builder.query<any, void>({
      query: () => ({
        url: 'api/referral/customer-referral-links/',
        method: 'GET',
      }),
    }),
    getService: builder.query<any, void>({
      query: () => ({
        url: 'api/referral/service/',
        method: 'GET',
      }),
    }),
    getReferralCodeByName: builder.query<any, string>({
      query: (name) => ({
        url: `api/referral/referral-service/${encodeURIComponent(name)}/`,
        method: 'GET',
      }),
    }),
    createReferralLinks: builder.mutation<any, any>({
      query: (body) => ({
        url: 'api/referral/customer-referral-links/',
        method: 'POST',
        body,
      }),
    }),
    getReferredUsers: builder.query<any, void>({
      query: () => ({
        url: 'api/referral/get-referred-users/',
        method: 'GET',
      }),
    }),
    sendReferralLink: builder.mutation<any, any>({
      query: (body) => ({
        url: 'api/referral/send-referral-code/',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetReferralLinksQuery,
  useGetServiceQuery,
  useGetReferralCodeByNameQuery,
  useCreateReferralLinksMutation,
  useGetReferredUsersQuery,
  useSendReferralLinkMutation,
} = referAPI;
